<div mat-dialog-content>
  <p> {{data.message}} </p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="OkClick()" >{{data.btnOK}}</button>
  <button mat-button color="primary" (click)="NokClick()" >{{data.btnNOK}}</button>
</div>